import { Add, Remove } from "@mui/icons-material";
import React, { useState } from "react";
import "./addxray.scss";
import ImagePreview from "../../../diagnose/components/imagePreview/ImagePreview";
interface ImageData {
  id: string;
  url: string;
  file: any;
  base64: any;
}
interface AddXrayProps {
  formData: ImageData[];
  setFormData: React.Dispatch<React.SetStateAction<ImageData[]>>;
  apiImage: any;
  handleRemove: any;
}

const AddXray: React.FC<AddXrayProps> = ({
  formData,
  setFormData,
  apiImage,
  handleRemove,
}: any) => {
  const [open, setopen] = useState(false);
  const [selectedImage, setselectedImage] = useState("");

  const onChangeHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (files && files.length > 0) {
      const newImages: ImageData[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const base64String = await fileToBase64(file);
        newImages.push({
          id: `image-${formData.length + i}`,
          url: URL.createObjectURL(file),
          file: file,
          base64: base64String,
        });
      }
      setFormData([...formData, ...newImages]);
      e.target.value = "";
    }
  };

  const removeImage = (id: string) => {
    const updatedImages = formData.filter((image: any) => image.id !== id);
    setFormData(updatedImages);
  };
  const fileToBase64 = (file: File) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result?.toString() ?? "");
      reader.onerror = (error) => reject(error);
    });
  };
  const openImage = (e: string) => {
    setopen(true);
    setselectedImage(e);
  }; 

  return (
    <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
      <div className="px-4 py-2.5 border-b border-slate-200">
        <h4 className="text-sm font-bold text-slate-800">X-Ray Images</h4>
      </div>
      <div className="p-3">
        <div className="addxray">
          <div className="xraycontainer">
        {apiImage?.map((image: any) => (
          <div key={image._id} className="image-item">
            <label htmlFor={image._id}>
              <img
                src={image.imageUrl}
                alt={`X-ray ${image._id}`}
                onClick={() =>
                  openImage(image.imageUrl)
                }
              />
            </label>
            <button onClick={() => handleRemove(image._id)}>
              <Remove />
            </button>
          </div>
        ))}
        {formData.map((image: any) => (
          <div key={image.id} className="image-item">
            <label htmlFor={image.id}>
              <img
                src={image.url}
                alt={`X-ray ${image.id}`}
                onClick={() => openImage(image.url)}
              />
            </label>
            <button onClick={() => removeImage(image.id)}>
              <Remove />
            </button>
          </div>
        ))}
        <div className="image-item">
          <label htmlFor={`selectimage${formData.length}`} className="xray">
            <Add />
          </label>
        </div>
        
        <input
          type="file"
          onChange={onChangeHandler}
          id={`selectimage${formData.length}`}
          name="xray"
          accept="image/*"
          style={{ display: "none" }}
          multiple // Allow multiple file selection
        />
          </div>
        </div>
      </div>
      {open && (
        <ImagePreview
          data={formData}
          selectedImage={selectedImage}
          setselectedImage={setselectedImage}
          setopen={setopen}
          apiImage={apiImage}
        />
      )}
    </div>
  );
};

export default AddXray;
